import { AppRegistry ,Alert} from "react-native";
import Links from "Links"
import './index.css';
//@ts-ignore
global.__DEV__=!process.env.NODE_ENV || process.env.NODE_ENV === 'development'
AppRegistry.registerComponent("App", () =>Links);
AppRegistry.runApplication("App", {
  rootTag: document.getElementById("root")
 });
Alert.alert=(title,message,buttons)=>{
  if (!buttons ){
  alert(title+"\n"+message)
  }
  else {
    
   let val=window.confirm(message)
   if ( val)
   buttons.find(x=>["Yes","Ok"].includes(x.text!))?.onPress?.apply(this)
   else 
   buttons.find(x=>x.text=="No")?.onPress?.apply(this)
   
  }
}
Alert.prompt=(title,message,buttons)=>{

  let r=prompt(title+"\n"+message)
  if (!r){
    (buttons as Array<any>).find(x=>x.text=="No")?.onPress?.apply(this)
  }
  else {
   let o= (buttons as Array<any>).find(x=>["Yes","Ok"].includes(x.text!))?.onPress
   if (o)
   o(r)
  }
}

// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
